// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__stO1j","newExpiryDate":"styles_newExpiryDate__2ElM6","footer":"styles_footer__3HQV9"};